import { Component, OnInit, OnDestroy } from '@angular/core';
import { SUPPORT_EMAIL } from 'src/app/constants/emailAndLinks';

declare global {
  interface Window {
    /** Android bridge injected by native WebView */
    NativeBridge?: {
      openEmail?: (email: string, subject?: string) => void;
      openExternalUrl?: (url: string) => void;
    };
    /** iOS bridge via WKScriptMessageHandler */
    webkit?: {
      messageHandlers?: {
        nativeBridge?: { postMessage: (msg: any) => void };
      };
    };
  }
}

@Component({
  selector: 'app-privacy-policy-webview',
  imports: [],
  templateUrl: './privacy-policy-webview.component.html',
  styleUrl: './privacy-policy-webview.component.scss'
})
export class PrivacyPolicyWebviewComponent implements OnInit, OnDestroy {
  SupportEmail = SUPPORT_EMAIL;
  private previousHtmlBackgroundColor = '';
  private previousBodyBackgroundColor = '';

  ngOnInit(): void {
    this.previousHtmlBackgroundColor = document.documentElement.style.backgroundColor;
    this.previousBodyBackgroundColor = document.body.style.backgroundColor;

    document.documentElement.style.backgroundColor = '#ffffff';
    document.body.style.backgroundColor = '#ffffff';
  }

  ngOnDestroy(): void {
    document.documentElement.style.backgroundColor = this.previousHtmlBackgroundColor;
    document.body.style.backgroundColor = this.previousBodyBackgroundColor;
  }

  /**
   * Opens an email via the native bridge.
   * Falls back to window.open for regular browsers.
   *
   * Android: window.NativeBridge.openEmail(email, subject)
   * iOS:     window.webkit.messageHandlers.nativeBridge.postMessage({ action: 'openEmail', email, subject })
   */
  openEmail(email: string, subject: string = ''): void {
    if (window.NativeBridge?.openEmail) {
      window.NativeBridge.openEmail(email, subject);
    } else if (window.webkit?.messageHandlers?.nativeBridge) {
      window.webkit.messageHandlers.nativeBridge.postMessage({ action: 'openEmail', email, subject });
    } else {
      window.open(`mailto:${email}${subject ? '?subject=' + encodeURIComponent(subject) : ''}`, '_self');
    }
  }

  /**
   * Opens an external URL via the native bridge (system browser).
   * Falls back to window.open for regular browsers.
   *
   * Android: window.NativeBridge.openExternalUrl(url)
   * iOS:     window.webkit.messageHandlers.nativeBridge.postMessage({ action: 'openExternalUrl', url })
   */
  openExternalUrl(url: string): void {
    if (window.NativeBridge?.openExternalUrl) {
      window.NativeBridge.openExternalUrl(url);
    } else if (window.webkit?.messageHandlers?.nativeBridge) {
      window.webkit.messageHandlers.nativeBridge.postMessage({ action: 'openExternalUrl', url });
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }
}
